export function updateLiveMarkers(timeLineMarkers, player, uiManager, autoFillTimeLineMarkerDuration) {
    if (!player || !uiManager) {
        console.error('Player or UIManager is null');
        return;
    }
    removeAllMarkers(uiManager);
    const currentTimeEpoch = Math.floor(Date.now() / 1000);
    timeLineMarkers.sort((a, b) => a.time - b.time);
    const relativeTimeMarkers = timeLineMarkers.map((marker, index) => transformMarker(marker, index, timeLineMarkers, currentTimeEpoch, player, autoFillTimeLineMarkerDuration));
    for (const marker of relativeTimeMarkers) {
        uiManager?.addTimelineMarker(marker);
    }
}
function transformMarker(marker, index, timeLineMarkers, currentTimeEpoch, player, autoFillTimeLineMarkerDuration) {
    const DVR_WINDOW_LENGTH = Math.abs(player.getMaxTimeShift());
    let duration = marker.duration === undefined ? 0 : marker.duration;
    let startTimeRelativeToCurrent = marker.time - currentTimeEpoch;
    if (autoFillTimeLineMarkerDuration) {
        duration =
            index === timeLineMarkers.length - 1
                ? Math.min(currentTimeEpoch, marker.time + DVR_WINDOW_LENGTH) - marker.time
                : timeLineMarkers[index + 1].time - marker.time;
        if (startTimeRelativeToCurrent < -DVR_WINDOW_LENGTH) {
            duration =
                index === timeLineMarkers.length - 1
                    ? currentTimeEpoch - (currentTimeEpoch - DVR_WINDOW_LENGTH)
                    : timeLineMarkers[index + 1].time - (currentTimeEpoch - DVR_WINDOW_LENGTH);
            startTimeRelativeToCurrent = -DVR_WINDOW_LENGTH;
        }
    }
    return {
        time: marker.time,
        duration: duration,
        title: marker.title,
        cssClasses: ['npo-livestream-marker']
    };
}
function removeAllMarkers(uiManager) {
    let existingTimelineMarkers = uiManager.getTimelineMarkers();
    while (existingTimelineMarkers.length > 0) {
        const marker = existingTimelineMarkers[0];
        const removed = uiManager?.removeTimelineMarker(marker);
        if (removed) {
            existingTimelineMarkers = uiManager.getTimelineMarkers();
            continue;
        }
        break;
    }
}
